import { render } from "./LottieAdapter.vue?vue&type=template&id=6d38900c"
import script from "./LottieAdapter.vue?vue&type=script&lang=js"
export * from "./LottieAdapter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__